export default __webpack_public_path__ + "static/media/a009-5.4a6fa81f.svg";